import UpperNavBar from "components/board/UpperNavBar";
import { JSX } from "react";
import { ProgressBar } from "./ProgressBar";
import { formatMessage } from "i18n/CurrentLocale";
import rawstrings from "string-translations/rawstrings";
import imgMyParkdVehicles from 'img/registration/myparkd-vehicles.png';


export const SplitPageTemplate = ({ LeftContent }: { LeftContent: JSX.Element }) => {
    return (
        <div id='page-onboarding' className='page-full-height'>
            <header className="header-row">
                <div className='grid'>
                    <UpperNavBar
                        backgroundColor="white"
                        logoRedirecsTo={formatMessage(rawstrings.parkdWebsiteHomeUrl)}
                        openInNewTab
                        showSupportPhoneNumber
                    />
                </div>
                <ProgressBar progress={100} />
            </header>

            <div className="flex-1-content">
                <aside className="column-left">
                    <div className='grid'>
                        {LeftContent}
                    </div>
                </aside>
                <main className="column-right">
                    <img id="onboarding-myparkd-screen" src={imgMyParkdVehicles} alt='MyParkd Dashboard' />
                </main>
            </div>
        </div>
    )
}
